var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.8125C8.76777 19.8125 9.1875 19.3928 9.1875 18.875C9.1875 18.3572 8.76777 17.9375 8.25 17.9375C7.73223 17.9375 7.3125 18.3572 7.3125 18.875C7.3125 19.3928 7.73223 19.8125 8.25 19.8125Z",
    fill: "#7161BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 19.8125C16.8928 19.8125 17.3125 19.3928 17.3125 18.875C17.3125 18.3572 16.8928 17.9375 16.375 17.9375C15.8572 17.9375 15.4375 18.3572 15.4375 18.875C15.4375 19.3928 15.8572 19.8125 16.375 19.8125Z",
    fill: "#7161BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30357 7.625H19.3214L17.259 14.8434C17.1844 15.1046 17.0267 15.3344 16.8099 15.4979C16.593 15.6615 16.3288 15.75 16.0571 15.75H8.56788C8.29624 15.75 8.03199 15.6615 7.81513 15.4979C7.59827 15.3344 7.4406 15.1046 7.36597 14.8434L4.54023 4.9533C4.50292 4.82271 4.42408 4.70782 4.31565 4.62603C4.20722 4.54424 4.07509 4.5 3.93928 4.5H2.625",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartSimple);
export default __webpack_public_path__ + "static/media/shoppingCartSimple.46382f25ef23cb401387b4fb4b4cc32a.svg";
export { ForwardRef as ReactComponent };